import { animate, style, transition, trigger } from "@angular/animations";

export const SLIDE_DOWN = trigger("slideDown", [
  // 열릴 때 애니메이션
  transition(":enter", [
    style({ transform: "translateY(-20px)", opacity: 0 }),
    animate(
      "300ms ease-in-out",
      style({ transform: "translateY(0)", opacity: 1 })
    ),
  ]),
  // 닫힐 때 애니메이션
  transition(":leave", [
    animate(
      "300ms ease-in-out",
      style({ transform: "translateY(-20px)", opacity: 0 })
    ),
  ]),
]);
